import React from 'react';
import styles from './owner-word.module.css';
import CTAButton from "../../../common/v2/CTA-Button/cta-button";
import Lazy from "../../../common/lazy-scroll/Lazy";
import {MDBIcon} from "mdb-react-ui-kit";

const OwnerWord: React.FC = () => {
    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper}>
                <div className={styles.image_container}>
                    {/*<img*/}
                    {/*    src="/images/banner/programoverview.jpg"*/}
                    {/*    alt="Espace chaleureux de la garderie"*/}
                    {/*    className={styles.image}*/}
                    {/*/>*/}
                    {/*<Lazy SrcImage={"/images/about/hijabavatar.jpg"}*/}
                    {/*      className={styles.image}*/}
                    {/*      alt={"Espace chaleureux de la garderie"}*/}
                    {/*/>*/}

                </div>
                <div className={styles.text_content}>
                    <h2 className={styles.section_title}>
                        Un mot de Fadila
                    </h2>
                    <p className={styles.intro_paragraph}>
                        <p className={styles.quote}>
                            <MDBIcon fas icon="quote-left" className="me-2"/>
                            Chaque enfant est unique, et mérite d’être entouré avec amour, patience et respect.
                            J’ai fondée cette garderie avec le cœur, pour offrir un lieu sûr et
                            stimulant aux familles de notre Communauté. Merci pour votre confiance.<MDBIcon fas icon="quote-right" className="me-2"/>
                        </p>
                    </p>
                    <CTAButton text={"Reservez une visite"} href={"/contact"}/>

                </div>
            </div>
        </section>
    );
};

export default OwnerWord;
